import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent, InactiveComponent} from './app.component';
import {ListAddRouteComponent, ListAdminComponent, ListComponent, ListSetTimeComponent, MessageComponent} from './list/list.component';
import {MapComponent} from './map/map.component';
import {SettingsComponent, SettingsFeedbackComponent} from './settings/settings.component';
import {SettingsDataService} from './settings-data.service';
import {HttpClientModule} from '@angular/common/http';
import {StorageServiceModule} from 'angular-webstorage-service';
import {FormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MaterialModule} from './material.module';
import {DlDateTimePickerDateModule} from 'angular-bootstrap-datetimepicker';
import {HistoryComponent} from './history/history.component';
import {NotSupportComponent} from './not-support/not-support.component';


@NgModule({
  declarations: [
    AppComponent,
    ListComponent,
    MapComponent,
    SettingsComponent,
    SettingsFeedbackComponent,
    ListSetTimeComponent,
    ListAddRouteComponent,
    ListAdminComponent,
    InactiveComponent,
    HistoryComponent,
    NotSupportComponent,
    MessageComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    StorageServiceModule,
    AppRoutingModule,
    FormsModule,
    MaterialModule,
    BrowserAnimationsModule,
    DlDateTimePickerDateModule
  ],
  entryComponents: [SettingsComponent, SettingsFeedbackComponent, InactiveComponent,
    ListComponent, ListSetTimeComponent, ListAddRouteComponent, ListAdminComponent, MessageComponent],
  providers: [SettingsDataService],
  bootstrap: [AppComponent]
})
export class AppModule {
}
